<template>
    <div>
        <p class="body-semibold">Documents</p>
        <p class="body-small text-valence-grey-750 mt-1">Upload strengths assessments, 360 feedback, performance reviews, or other documents that reflect how you work.</p>
    </div>
</template>
